import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../Component/ui/tabs";
import { Calendar, CalendarCheck, CalendarX } from "lucide-react";
import CalendarView from "../../Component/Availability/CalenderView";
import Unavialable from "../../Component/Availability/Unavialable";
import IMAGES from "../../constants/images";
import { isMobile } from "react-device-detect";
import { navigateTo, getPathSegment } from "../../utils/navigation";

export default function Index() {
  const [aid, setAid] = useState(getPathSegment(2));
  const [collapsed, setCollapsed] = useState(false);

  const [activeTab, setActiveTab] = useState(
    aid === "available" || aid.includes("date")
      ? "availability"
      : "unavailability"
  );

  if (isMobile) {
    return (
      <div className="fixed inset-0 flex justify-center items-center bg-[#FFFFFF] overflow-auto transition-all duration-300">
        <div>
          <center>
            <img
              src={IMAGES.on_web}
              className="w-[220px] h-[220px]"
              alt="on_web"
            />
            <p className="text-[18px] font-poppins font-medium text-[#171717] text-center">
              For availability settings, please use a laptop/desktop browser
            </p>
          </center>
        </div>
      </div>
    );
  }

  return (
    <div className="flex bg-[#F8FAFC] min-h-screen mt-[80px]">
      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] w-full pt-2 px-2 pb-2 flex flex-col transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="w-full bg-[#FFFFFF] p-4 md:p-4 rounded-2xl">
          <div className="w-full rounded-lg bg-white p-2 md:p-2">
            <div className="inline-flex items-center gap-1 p-1.5 mb-2 bg-white rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm">
              <button
                className={`flex items-center justify-center gap-2 px-4 py-2 h-[40px] rounded-xl border-0 text-sm font-semibold font-poppins transition-all ${activeTab === "availability"
                  ? "bg-[#0F172A] text-white shadow-md"
                  : "bg-[#F8FAFC] text-[#334155] hover:bg-gray-100"
                  }`}
                onClick={() => {
                  navigateTo("/set-availability/available");
                }}
              >
                <CalendarCheck size={18} className="flex-shrink-0" />
                <span>Availability</span>
              </button>
              <button
                className={`flex items-center justify-center gap-2 px-4 py-2 h-[40px] rounded-xl border-0 text-sm font-semibold font-poppins transition-all ${activeTab === "unavailability"
                  ? "bg-[#0F172A] text-white shadow-md"
                  : "bg-[#F8FAFC] text-[#334155] hover:bg-gray-100"
                  }`}
                onClick={() => {
                  navigateTo("/set-availability/unavailable");
                }}
              >
                <CalendarX size={18} className="flex-shrink-0" />
                <span>Unavailability</span>
              </button>
            </div>
            <div className="mt-2">
              {activeTab === "availability" ? (
                <CalendarView mode="availability" />
              ) : (
                <Unavialable mode="unavailability" />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
